const Header = () => {
  return (
    <div>
      <h1 className="header" style={{textAlign: "center", color: 'purple', padding: '25px', fontSize: '48px'}}>Candy Bash</h1>
    </div>
  )
}

export default Header